export default __webpack_public_path__ + "9057c3a00df20dbb400071ccffa624f9.svg";